import { AdminMessage } from "@components/atoms/AdminMessage"
import { Button } from "@components/atoms/Button"
import { Chip } from "@components/atoms/Chip"
import { ColourTheme } from "@components/atoms/ColourTheme"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { getTranslation } from "@utils/Translations"
import { cn } from "@utils/tw"
import dayjs from "dayjs"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Featured Post",
  tags: ["#page"],
}

export default defineBlock("section/featured-post", (props) => {
  const item = props.blogPost || props.event || props.caseStudy || props.press || props.insight
  const category = item?.__typename === "Event" ? [item.category] : item?.categories?.nodes || []
  const readTime = item && "readTime" in item ? item.readTime : undefined
  const defaultTheme = item?.__typename === "Blog" ? props.defaultBlogColour : props.defaultColour
  const theme = item && "headerData" in item ? item.headerData?.colourTheme || defaultTheme : defaultTheme
  const showExcerpt = item?.__typename !== "Blog"
  const isInsight = item?.__typename === "Insight"

  return (
    <Appear className="featured-post flex w-maxContentW px-6 my-9 mx-auto">
      {!item ? (
        <AdminMessage>Select a post in the right panel</AdminMessage>
      ) : (
        <Link href={item?.uri || "#"} className="w-full group">
          <ColourTheme
            theme={!isInsight ? theme : undefined}
            className={cn(
              "w-full flex flex-col md:flex-row justify-between rounded-md md:group-hover:rounded-lg transition-all duration-300 overflow-hidden",
              isInsight && "justify-center",
            )}
          >
            <div
              className={cn(
                "w-full md:h-auto aspect-[320/213] md:aspect-auto md:self-stretch",
                isInsight && "md:w-insightHeaderImageW md:shrink-0 md:self-auto rounded-mdu overflow-hidden",
              )}
            >
              {item?.featuredImage?.node && (
                <ResponsiveImage {...item.featuredImage.node} className="w-full h-full object-cover" />
              )}
            </div>
            <div
              className={cn(
                "w-full md:w-[40%] shrink-0 md:aspect-[488/475] p-7 flex items-center justify-center",
                isInsight && "md:w-featuredPostInsightTextW md:shrink-[1] md:aspect-auto md:px-0 md:ml-10",
              )}
            >
              <div className="flex flex-col gap-5">
                <div className="flex gap-2 items-center">
                  {category.length > 0 &&
                    category.map(
                      (cat, cx) => !!cat && <Chip key={cx}>{typeof cat === "string" ? cat : cat.name}</Chip>,
                    )}
                </div>
                <h2 className="type-header-2-xl" dangerouslySetInnerHTML={{ __html: item.title || "" }} />
                {showExcerpt && (
                  <div
                    className="my-0 type-body-m md:line-clamp-3"
                    dangerouslySetInnerHTML={{ __html: item?.excerpt || "" }}
                  />
                )}
                {isInsight ? (
                  <Button href={item?.uri || "#"} dark>
                    {getTranslation("readMore")}
                  </Button>
                ) : (
                  <>
                    <p className="type-ui-label flex items-center gap-2">
                      <span>{dayjs(item?.date).format("MMM DD YYYY")}</span>
                      {readTime && (
                        <>
                          <span>・</span>
                          <span>{readTime}</span>
                        </>
                      )}
                    </p>
                    <Button
                      href={item?.uri || "#"}
                      dark
                      className="hidden md:flex opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    >
                      {getTranslation("readMore")}
                    </Button>
                  </>
                )}
              </div>
            </div>
          </ColourTheme>
        </Link>
      )}
    </Appear>
  )
})
